navigation = {
    init: function () {
        $('.js-navigation-trigger').on('click', function() {
            $('.js-navigation-trigger, .js-navigation').attr('aria-expanded', function (i, attr) {
                return attr == 'true' ? 'false' : 'true'
            });
        });
    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/navigation.js